const _ = require('underscore');

class RawCaptionsDataExtractor {
    constructor() {

    }

    extractCaptionModels(collection) {
        return collection.map(c => this._extractCaptionRawData(c));
    }

    getIndexById(collection, captionId) {
        return collection.findIndex(c => c.get('id') == captionId);
    }

    _extractCaptionRawData(caption) {
        return _.extend({}, caption.getCurrentModel().attributes, {id: caption.get('id')});
    }
}

module.exports = new RawCaptionsDataExtractor();


// WEBPACK FOOTER //
// ./app/helpers/raw-captions-data-extractor.js